import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { SharedUiAddChildContactInfoModule } from '@se-po/shared-ui-add-child-contact-info'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiAddChildProfileModule } from '../lib/shared-ui-add-child-profile.module'
import { AddChildProfileDocsComponent } from './add-child-profile-docs/add-child-profile-docs.component'
import { AddChildContactInfoExampleComponent } from './add-child-profile-docs/examples/add-child-contact-info-example.component'
import { AddChildProfileExampleComponent } from './add-child-profile-docs/examples/add-child-profile-example.component'

@NgModule({
  declarations: [
    AddChildContactInfoExampleComponent,
    AddChildProfileDocsComponent,
    AddChildProfileExampleComponent
  ],
  exports: [AddChildProfileDocsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiAddChildContactInfoModule,
    SharedUiAddChildProfileModule
  ],
})
export class SharedUiAddChildProfileDocsModule { }
